import React, { useContext, Fragment, useEffect } from "react";
import Select from "react-select";
import { DocumentoContext } from "../DocumentoContext";
import Pesquisar from "../../../../../Components/Cadastro/Pesquisar/Pesquisar";
import TabelaResultados from "../../../../../Components/Cadastro/TabelaResultados/TabelaResultados";
import {
  ListarSubTipoDocs
} from "../../../../../Services/TipoDocs";

const PesquisarDocumento = () => {
  const { values, setValues, resetScreen, styleSelect, obterSubtipos } = useContext(DocumentoContext);

  useEffect(() => {
    resetScreen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function onChangeInput(event) {
    const { name, value } = event.target;
    setValues({
      ...values,
      searchData: {
        ...values.searchData,
        [name]: value,
      },
    });
  }
  const handleChangeTipo = async (tipoDoc) => {

    const subtipos = await obterSubtipos(tipoDoc ? tipoDoc.value : 0)

    let itemVazio = { value: 0, label: "Todos" };
    const subTiposDocs = [
      itemVazio,
      ...subtipos
        .filter((item) => item.subTipoDocsStatus === "A")
        .map((sub) => ({
          value: sub.subTipoDocsId,
          label: sub.subTipoDocsNome,
        })),
    ];

    setValues({
      ...values,
      subTiposDocs,
      searchData: {
        ...values.searchData,
        tipoDocsId: tipoDoc ? tipoDoc.value : 0,
        tipoDoc,
        subTipoDocsId: 0,
        subTipoDoc: itemVazio,
      },
    });
  };

  const handleChangeSubTipo = (subTipoDoc) => {
    setValues({
      ...values,
      searchData: {
        ...values.searchData,
        subTipoDocsId: subTipoDoc ? subTipoDoc.value : 0,
        subTipoDoc,
      },
    });
  };

  return (
    <Fragment>
      <Pesquisar context={DocumentoContext}>
        <div className="col-12 col-md-3">
          <label>Tipo</label>
          <Select
            styles={styleSelect}
            placeholder=""
            value={values.searchData.tipoDoc}
            onChange={handleChangeTipo}
            options={values.tiposDocs}
          />
        </div>
        <div className="col-12 col-md-3">
          <label>Sub Tipo</label>
          <Select
            styles={styleSelect}
            placeholder=""
            value={values.searchData.subTipoDoc}
            onChange={handleChangeSubTipo}
            options={values.subTiposDocs}
          />
        </div>
        <div className="col-12 col-md-12 mt-3">
          <label>Critério de Busca</label>
          <input
            className="form-control"
            type="text"
            name="criterioBusca"
            value={values.searchData.criterioBusca || ""}
            onChange={onChangeInput}
          />
        </div>
      </Pesquisar>
      <TabelaResultados context={DocumentoContext} />
    </Fragment>
  );
};

export default PesquisarDocumento;
